module.exports = __webpack_public_path__ + "static/assets/43f8dc8949ea47e4c49bf228e351f99b.png";